<template>
  <a-card>
    <span slot="title">Prospect Notification Form</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="Prospect Details" />
      <a-step title="Supporting documents" />
      <a-step title="Pipeline" />
      <a-step title="Approval" />
    </a-steps>
    <div class="steps-content flex-1">
      <component
        class="flex-1"
        :is="steps[current].content"
        :ref="stepRef"
        v-bind="stepProps"
      ></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next"
          >Next</a-button
        >
        <a-button
          v-if="current == steps.length - 1"
          type="primary"
          @click="validate"
          >Save</a-button
        >
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import qs from "qs";
import moment from "moment";
import Informasi from "./steps/Informasi.vue";
import DetailProspect from "./steps/DetailProspect.vue";
import DokumenPendukung from "./steps/DokumenPendukung.vue";
import Pipeline from "./steps/Pipeline.vue";
import Persetujuan from "./steps/Persetujuan.vue";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "ProspectNotificationCreate",
  props: ["id"],
  mixins: [GlobalMethod],
  components: {
    Informasi,
    DetailProspect,
    DokumenPendukung,
    Persetujuan,
    Pipeline,
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "DetailProspect",
          content: "DetailProspect",
        },
        {
          title: "DokumenPendukung",
          content: "DokumenPendukung",
        },
        {
          title: "Pipeline",
          content: "Pipeline",
        },
        {
          title: "Persetujuan",
          content: "Persetujuan",
        },
      ],
      mode: "Create",
      collectData: {},
      listProspect: [],
      listCustomer: [],
      listBawahan: [],
      postData: new FormData(),
      postJson: {},
      editData: {},
      listDokumen: [],
      dokumenPendukung: [],
    };
  },
  computed: {
    ...mapGetters(["getAuth"]),
    initialListItem() {
      let data = [];
      if (this.mode === "Edit") {
        this.listProspect.forEach((item) => {
          //hargaTotal = item.values.jumlah * item.values.harga;
          const values = item.values;
          data = [...data, { values }];
        });
      } else {
        data = this.listProspect;
        this.collectData.listBeli.forEach((item) => {
          data = [
            ...data,
            {
              values: item,
            },
          ];
        });
      }
      return data;
    },
    stepProps: function () {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            mode: this.mode,
            listCustomer: this.listCustomer,
            listBawahan: this.listBawahan
          };
        } else if (this.steps[this.current].content === "DetailProspect") {
          return {
            listDokumen: this.listDokumen,
            listProspect: this.initialListItem,
            mode: "Edit",
          };
        } else if (this.steps[this.current].content === "DokumenPendukung") {
          return {
            listDokumen: this.listDokumen,
            informasi: this.collectData.informasi,
            mode: "Edit",
          };
        } else if (this.steps[this.current].content === "Pipeline") {
          return {
            listDokumen: this.listDokumen,
            informasi: this.collectData.informasi,
            pipelineSource: this.collectData.pipeline,
            mode: "Edit",
          };
        } else if (this.steps[this.current].content === "Persetujuan") {
          return {
            data: this.collectData.informasi,
            informasi: this.collectData.informasi,
            approval: this.collectData.approval,
            mode: this.mode,
          };
        }
      } else if (this.mode === "Create") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            dokumenPendukung: this.collectData.dokumenPendukung,
            mode: this.mode,
            listCustomer: this.listCustomer,
            listBawahan: this.listBawahan
          };
        } else if (this.steps[this.current].content === "DetailProspect") {
          return {
            listDokumen: this.listDokumen,
            listProspect: this.listProspect,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content === "DokumenPendukung") {
          return {
            listDokumen: this.listDokumen,
            listProspect: this.listProspect,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content === "Pipeline") {
          return {
            listDokumen: this.listDokumen,
            listProspect: this.listProspect,
            pipelineSource: this.collectData.pipeline,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content === "Persetujuan") {
          this.collectData.informasi.approval = JSON.parse(
            JSON.stringify(this.dokumenPendukung.approval)
          );
          return {
            data: this.collectData.informasi,
            informasi: this.collectData.informasi,
            mode: this.mode,
          };
        }
      }
      return true
    },
    stepRef: function () {
      if (this.steps[this.current].content === "Informasi") {
        return "refInformasi";
      } else if (this.steps[this.current].content === "DetailProspect") {
        return "refDetailProspect";
      } else if (this.steps[this.current].content === "DokumenPendukung") {
        return "refDokumenPendukung";
      } else if (this.steps[this.current].content === "Pipeline") {
        return "refPipeline";
      } else if (this.steps[this.current].content === "Persetujuan") {
        return "refPersetujuan";
      }
      return true
    },
  },
  created() {
    if (this.id) {
      this.mode = "Edit";
      this.fetchDetail();
    }

    this.asyncAxiosGet(
            "rnd_notification/product",
            this.getAuth,
            { 
              tlc: this.getAuth.username
            }
        ).then((response) => {
            this.listCustomer = response.list_customer;
            this.listBawahan = response.bawahan;

        }).catch((err) => {
            console.log(err);
        });
  },
  methods: {
    moment,
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "DetailProspect") {
        this.$refs.refDetailProspect.handleRef();
      } else if (this.steps[this.current].content === "DokumenPendukung") {
        this.$refs.refDokumenPendukung.handleRef();
      } else if (this.steps[this.current].content === "Pipeline") {
        this.$refs.refPipeline.handleRef();
      }
    },
    prev() {
      // if (this.steps[this.current].content === "DokumenPendukung") {
      //   this.$refs.refDokumenPendukung.handleRefBack();
      // }
      this.current--;
    },
    validate() {
      this.$refs.refPersetujuan.handleRef();
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        if (this.mode === "Create") {
          this.collectData.informasi = JSON.parse(
            JSON.stringify(value.informasi)
          );
        } else {
          const catatan = this.collectData.informasi.note;
          this.collectData.informasi = JSON.parse(
            JSON.stringify(value.informasi)
          );
          this.collectData.informasi.catatan = catatan;
        }
        this.current++;
      } else if (this.steps[this.current].content === "DetailProspect") {
        // this.collectData.listProspect = JSON.parse(
        //   JSON.stringify(value.listProspect)
        // );
        this.current++;
      } else if (this.steps[this.current].content === "DokumenPendukung") {
        // if (this.collectData.length > 2) {
        //   this.collectData.push(JSON.parse(JSON.stringify(value)));
        // } else {
        //   this.dokumenPendukung = value;
        // }
        this.dokumenPendukung = value;

        this.current++;
      } else if (this.steps[this.current].content === "Pipeline") {
        this.collectData.pipeline = value.pipeline;
        this.current++;
      } else if (this.steps[this.current].content === "Persetujuan") {
        this.collectData.persetujuan = JSON.parse(
          JSON.stringify(value.persetujuan)
        );

        if (this.mode === "Edit") {
          this.confirmMessage("confirm-edit");
        } else {
          this.confirmMessage("confirm-save");
        }
      }
    },
    // valueFromChild2(value) {
    //   if (this.steps[this.current].content === "DokumenPendukung") {
    //     this.dokumenPendukung = value;
    //     this.current++;
    //   }
    // },
    getUpdateListProspect(item) {
      this.listProspect = item;
    },
    getListProspect(item) {
      this.listProspect = [
        ...this.listProspect,
        JSON.parse(JSON.stringify(item)),
      ];
      //ascending
      this.listProspect.sort(function (a, b) {
        return a.values.keyIndex - b.values.keyIndex;
      });
    },
    getUpdateDokumenrefBack(item) {
      this.listDokumen = item;
    },
    getUpdateDokumen(item) {
      //console.log(item);
      this.listDokumen.dokumenPendukung = item;
      //console.log("submit");

      // if (this.mode === "Edit") {
      //   this.confirmMessage("confirm-edit");
      // } else {
      //   this.confirmMessage("confirm-save");
      // }
    },
    setSubmitForm() {
      if (this.mode === "Edit") {
        this.postData.append("id_manifest", this.id);
      }
      this.postData.append("tlc", this.getAuth.username);

      this.postData.append("tanggal", moment(this.collectData.informasi.tanggal).format('YYYY-MM-DD'));
      this.postData.append("description", this.collectData.informasi.deskripsi);
      this.postData.append(
        "customer",
        this.collectData.informasi.customer_nm
      );
      this.postData.append(
        "est_nilai_penjualan",
        this.collectData.informasi.estimate_project_cost
      );
      this.postData.append(
        "est_biaya_prospek",
        this.collectData.informasi.estimate_prospect_cost
      );

      this.postData.append(
        "catatan",
        this.collectData.persetujuan.catatan?this.collectData.persetujuan.catatan:""
      );

      let i = 0;
      this.listProspect.forEach((data) => {
        this.postData.append("nama_barang[" + i + "]", data.values.nama_barang);
        // this.postData.append("pn[" + i + "]", data.values.pn);
        this.postData.append("note[" + i + "]", data.values.note);
        // this.postData.append(
        //   "jumlah_barang[" + i + "]",
        //   data.values.jumlah_barang
        // );
        // this.postData.append("satuan[" + i + "]", data.values.satuan);
        i++;
      });

      if (this.listDokumen.dokumenPendukung) {
        i = 0;
        this.listDokumen.dokumenPendukung.forEach((data) => {
          if (!data.id_prospek_doc) {
            this.postData.append("nama_document[" + i + "]", data.file);
            this.postData.append(
              "deskripsi_doc[" + i + "]",
              data.deskripsi_doc
            );
            i++;
          }
        });

        i = 0;
        this.listDokumen.dokumenPendukung.forEach((data) => {
          if (data.id_prospek_doc) {
            this.postData.append("old_doc[" + i + "]", data.id_prospek_doc);
            i++;
          }
        });
      }

      if (this.mode === "Create") {
        i = 0;
        this.dokumenPendukung.approval.forEach((data) => {
          for (const key in this.collectData.persetujuan) {
            if(data.nama_bidang.replace(/\s/g, '').toLowerCase()==key){
              this.postData.append("tlc_actor[" + i + "]", data.tlc=='-' ? this.collectData.persetujuan[key] : data.tlc);
              this.postData.append("actor[" + i + "]", data.nama_bidang);
            }
          }
          // if (data.nama_bidang == "Vice President Marketing") {
          //   i++;
          //   this.postData.append(
          //     "tlc_actor[" + i + "]",
          //     this.collectData.persetujuan.chif
          //   );
          //   this.postData.append(
          //     "actor[" + i + "]",
          //     "Chief Operation Officer / Site Manager"
          //   );
          // }
          i++;
        });
      }

      //Create Pipeline
        if (this.collectData.pipeline.pipeline_id) {
          this.postData.append("pipeline_id", this.collectData.pipeline.pipeline_id);
        }
        if(this.collectData.pipeline.id_prospek)
          this.postData.append("id_prospek", this.collectData.pipeline.id_prospek);
        this.postData.append("definition", this.collectData.pipeline.definition);
        this.postData.append("description", this.collectData.pipeline.description);
        this.postData.append("end_user", this.collectData.pipeline.end_user);
        if(this.collectData.pipeline.pic)
          this.postData.append("pic", this.collectData.pipeline.pic);
        if(this.collectData.pipeline.pimpro)
          this.postData.append("pimpro", this.collectData.pipeline.pimpro);
        if(this.collectData.pipeline.contact_details)
          this.postData.append("contact_details", this.collectData.pipeline.contact_details);
        this.postData.append("currency", this.collectData.pipeline.currency);
        this.postData.append("exchange_rate", this.collectData.pipeline.exchange_rate);
        this.postData.append("est_contract_value", this.collectData.pipeline.est_contract_value);
        // this.postData.append("est_gross_profit", this.collectData.pipeline.est_gross_profit);
        // this.postData.append("est_gross_profit_prosen", this.collectData.pipeline.est_gross_profit_prosen);
        this.postData.append("est_operasional_cost", this.collectData.pipeline.est_operasional_cost);
        this.postData.append("est_marketing_cost", this.collectData.pipeline.est_marketing_cost);
        this.postData.append("est_ga_cost", this.collectData.pipeline.est_ga_cost?this.collectData.pipeline.est_ga_cost:0);
        this.postData.append("est_finance_cost", this.collectData.pipeline.est_finance_cost);
        this.postData.append("status", this.collectData.pipeline.status);
        this.postData.append("kategori", this.collectData.pipeline.category);
        this.postData.append("year", this.collectData.pipeline.year);
        // this.postData.append("progress", this.collectData.pipeline.progress);
        this.postData.append("notes", this.collectData.pipeline.note ? this.collectData.pipeline.note : "");
      //end
    },
    submit() {
      this.setSubmitForm();
      let method = "";
      let data;
      let url;
      if (this.mode === "Create") {
        method = "post";
        data = this.postData;
        url = "prospek";
      } else {
        method = "post";
        data = this.postData;
        url = "prospek/edit";
      }
      axios({
        method: method,
        url: this.$serviceUrl + url,
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          if (this.mode === "Create") {
            this.displayMessage("success-save");
          } else {
            this.displayMessage("success-edit");
          }
          this.current = 0;
          this.$router.push({ name: "prospectNotification" });
        })
        .catch((err) => {
          console.log("error : " + err);
        });
    },
    fetchDetail() {
      axios({
        method: "get",
        url: this.$serviceUrl + "prospek/edit",
        params: {
          id_manifest: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.collectData = {
            informasi: response.data.header[0],
            dokumenPendukung: response.data.dokumen,
            listProspect: response.data.detil,
            approval: response.data.approval,
            pipeline: {
              pipeline_id: response.data.pipeline ? response.data.pipeline.pipeline_id : null,
              definition: response.data.pipeline ? response.data.pipeline.definitions : null,
              description: response.data.pipeline ? response.data.pipeline.description : null,
              end_user: response.data.pipeline ? response.data.pipeline.client : null,
              pic: response.data.pipeline ? response.data.pipeline.pic_am : null,
              pimpro: response.data.pipeline ? response.data.pipeline.pic_pimpro : null,
              contact_details: response.data.pipeline ? response.data.pipeline.contact_detail : null,
              currency: response.data.pipeline ? response.data.pipeline.currency : null,
              exchange_rate: response.data.pipeline ? response.data.pipeline.kurs : null,
              est_contract_value: response.data.pipeline ? response.data.pipeline.est_contract_value : null,
              est_operasional_cost: response.data.pipeline ? response.data.pipeline.est_operasional_cost : null,
              est_marketing_cost: response.data.pipeline ? response.data.pipeline.est_marketing_cost : null,
              est_ga_cost: response.data.pipeline ? response.data.pipeline.est_ga_cost : null,
              est_finance_cost: response.data.pipeline ? response.data.pipeline.est_finance_cost : null,
              status: response.data.pipeline ? response.data.pipeline.status : null,
              category: response.data.pipeline ? response.data.pipeline.kategori : null,
              year: response.data.pipeline ? response.data.pipeline.year : null,
              note: response.data.pipeline ? response.data.pipeline.notes : null,
            }
          };

          this.listDokumen = {
            informasi: response.data.header[0],
            dokumenPendukung: response.data.dokumen,
          };

          let keyforEach = 0;
          response.data.detil.forEach((item) => {
            this.listProspect = [
              ...this.listProspect,
              {
                values: {
                  keyIndex: keyforEach,
                  // jumlah_barang: item.jumlah_barang,
                  nama_barang: item.nama_barang,
                  // satuan: item.satuan,
                  pn: item.pn,
                  note: item.note,
                },
              },
            ];
            keyforEach++;
          });
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          console.log(responses);
          this.displayMessageValue("error", responses);
        });
    },
    postUpdateDoc() {
      let longSize = this.listDokumen.deleteExistingDoc.length;
      let vLoop = 1;

      this.listDokumen.deleteExistingDoc.forEach((item) => {
        let urlEncodeValue = qs.stringify({
          id: item[0].id_salesnotif_doc,
        });

        axios({
          method: "delete",
          url: this.$serviceUrl + "rnd_notification/document",
          processData: false,
          data: urlEncodeValue,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            if (vLoop === longSize) {
              this.displayMessage("success-edit");
            }
            vLoop++;
          })
          .catch((err) => {
            let responses = Object.assign({}, err.response.data);
            console.log(responses);
            this.displayMessageValue("error", responses);
          });
      });
    },
  },
  mounted() {
    Event.$on("ProspectNotifData", this.valueFromChild);
    Event.$on("listProspect", this.getListProspect);
    Event.$on("updateDokumen", this.getUpdateDokumen);
    Event.$on("updateDokumenRefBack", this.getUpdateDokumenrefBack);
    Event.$on("UpdateListProspect", this.getUpdateListProspect);
    Event.$on("confirmMessageReturn", this.submit);
  },
  beforeDestroy() {
    Event.$off("ProspectNotifData", this.valueFromChild);
    Event.$off("listProspect", this.getListProspect);
    Event.$off("updateDokumen", this.getUpdateDokumen);
    Event.$off("updateDokumenRefBack", this.getUpdateDokumenrefBack);
    Event.$off("UpdateListProspect", this.getUpdateListProspect);
    Event.$off("confirmMessageReturn", this.submit);
  },
};
</script>

<style></style>
